var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchiveRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.324,
    height: 16.324
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31466",
    d: "M0 0h16.324v16.324H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31467",
    d: "M13.971 3.558l-.945-1.143a.987.987 0 00-.785-.374H4.082a1.011 1.011 0 00-.789.374l-.939 1.143a1.332 1.332 0 00-.313.864v8.5a1.364 1.364 0 001.36 1.36h9.522a1.364 1.364 0 001.36-1.36v-8.5a1.332 1.332 0 00-.312-.864zm-9.73-.157h7.836l.551.66H3.701l.54-.66zm-.84 9.523V5.441h9.522v7.482zm5.747-6.122H7.176v2.039H5.441l2.721 2.721 2.721-2.721H9.149z",
    fill: "#fa0043",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
}

export default SvgArchiveRed;